import React, { useContext } from "react";
import { ProductSelectContext } from "../store/ProductSelectContext.jsx";
import * as Sentry from "@sentry/react";
import "../scss/product-item.scss";

function ProductItem({ product }) {
    const { setProductSelected } = useContext(ProductSelectContext);
    return (
        <div
            className="product-item col-3 my-2"
            onClick={() => {
                product.availableForSale && setProductSelected(product)
                // setProductSelected(product)
            }}
        >
            {/* if product not available for sale, add gray overlay */}
            <div className="card" style={{ opacity: product.availableForSale ? 1 : 0.5 }}>
                <img src={product.imgSrc} className="item-thumbnail card-img-top" alt={product.imgAltText} />
                <div className="card-body text-left">
                    <h5 className="card-title">{product.title}</h5>
                    <h6 className="card-subtitle text-body-secondary">${product.price}</h6>
                    {/* <p className="card-text">
                        Price: {product.price}<br />
                        SKU: {product.sku}<br />
                        Available for sale: {product.availableForSale ? 'Yes' : 'No'}<br />
                        Quantity Available: {product.quantityAvailable}
                    </p> */}
                </div>

            </div>
        </div>
    );
}

export default Sentry.withProfiler(ProductItem);